export default $(()=>{
    let $productCategoryLink = $('.product-category--link');

    $productCategoryLink.on('click', function() {
        //console.log('click');
    });
});